import * as React from "react";
import classnames from "classnames";
import { Star, Sizes } from "./Star.js";
/* empty css           */
const Stars = ({
  className,
  rating,
  count = 5,
  size = Sizes.large,
  color
}) => {
  const getFill = (index, rating2) => {
    const ratingMinusOffset = Math.max(0, rating2 - index);
    const fill = Math.min(1, Math.round(ratingMinusOffset * 10 / (0.5 * 10)) * 0.5);
    return fill;
  };
  const array = React.useMemo(() => Array.from({ length: count }), [count]);
  return /* @__PURE__ */ React.createElement("div", { className: classnames("store-rating-stars", className) }, array.map((_entry, index) => /* @__PURE__ */ React.createElement(
    Star,
    {
      className: "store-rating-star",
      key: `star-${index}`,
      fill: getFill(index, rating),
      size,
      color
    }
  )));
};
export {
  Stars,
  Stars as default
};
//# sourceMappingURL=Stars.js.map
